module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-root"
  }, [_c('div', {
    staticClass: "message-box"
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      staticClass: "message"
    }, [_c('div', {
      staticClass: "icon-box"
    }, [_c('i', {
      staticClass: "iconfont",
      domProps: {
        "innerHTML": _vm._s(message.icon)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('span', [_vm._v(_vm._s(message.title))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('span', [_vm._v(_vm._s(message.content))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebb67e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/resume/components/page2.vue
// module id = 190
// module chunks = 0